export namespace GameEvent {
    //更换场景前
    export const CHANGE_SCENE_BEFORE: string = 'GameEvent.CHANGE_SCENE_BEFORE';
    //更换场景后
    export const CHANGE_SCENE_AFTER: string = 'GameEvent.CHANGE_SCENE_AFTER';
}